export const TEST_EMAIL = 'test@test.com';
export const TEST_PASSWORD = 'test';
export const TEST_RECAPTCHA_KEY = '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI';

export const RECAPTCHA_KEY = '6LfMg5YUAAAAAAJr_ANH5TVvhoSHsJEa6oGSHw6f';
